import { CouponTypeEnum } from 'common/enums/CouponTypeEnum'
import { useSelectedOfferPricing } from 'publisher/pages/offer-page/hooks/useSelectedOfferPricing'
import { usePayment } from 'publisher/store'
import {
  getActivePricePlan,
  getCheckedCoupon,
  getProduct,
  getProductActiveVariant,
} from 'publisher/store/payment/paymentSelectors'
import { useMemo } from 'react'

export const useIsHundredPercentDiscount = (): boolean => {
  const coupon = usePayment(getCheckedCoupon)
  const product = usePayment(getProduct)
  const pricePlan = usePayment(getActivePricePlan)
  const activeProductVariant = usePayment(getProductActiveVariant)

  const selectedOfferPricing = useSelectedOfferPricing({
    selectedProduct: product,
    selectedPricePlan: pricePlan,
    activeProductVariant,
  })

  return useMemo(() => {
    return (
      (coupon?.discountType === CouponTypeEnum.Percent &&
        coupon?.discountAmount === 100) ||
      (coupon?.discountType === CouponTypeEnum.Fixed &&
        coupon?.discountAmount >= (selectedOfferPricing?.originalAmount ?? 0))
    )
  }, [coupon, selectedOfferPricing])
}
